module.exports = __webpack_public_path__ + "img/fineness-1@2x.7ea0733.webp";